import type {HydratedAPITask} from '../types/api-task'
import type {Session} from '../types/session'
import type {UITask} from '../types/task'
import {COPILOT_CLI_SLUG} from './agent-helpers'

/**
 * Checks if a slug belongs to the Copilot CLI.
 */
export function isCLIAgentSlug(slug: string | undefined): boolean {
  return slug === COPILOT_CLI_SLUG
}

/**
 * Checks if a session belongs to the Copilot CLI agent.
 * Uses slug-based detection via the agent_slug field on the session.
 */
export function isCLISession(session: Session | null | undefined): boolean {
  if (!session) return false
  return isCLIAgentSlug(session.agent_slug)
}

/**
 * Checks if a task was created by the Copilot CLI.
 * Uses slug-based detection.
 */
export function isTaskFromCLI(task: UITask | null | undefined): boolean {
  if (!task) return false
  return isCLIAgentSlug(task.agentSlug)
}

/**
 * Checks if an API task was created by the Copilot CLI.
 * Uses slug-based detection.
 */
export function isAPITaskFromCLI(task: HydratedAPITask | null | undefined): boolean {
  if (!task) return false
  return task.agent_collaborators?.some(c => isCLIAgentSlug(c.slug)) ?? false
}
